export const ShareIcon = () => {
  return (
    <g id="share" transform="translate(-3 -4.517)">
      <path
        id="Path_34388"
        data-name="Path 34388"
        d="M4,20a1.042,1.042,0,0,1-.286-.042A1,1,0,0,1,3,19V18a9.98,9.98,0,0,1,8-9.8V6.5a1.99,1.99,0,0,1,.585-1.414,2.048,2.048,0,0,1,2.829,0l6.288,6.2a1,1,0,0,1,0,1.424l-6.293,6.207a2.05,2.05,0,0,1-2.823,0A1.986,1.986,0,0,1,11,17.5V16.062a7.347,7.347,0,0,0-6.164,3.484A1,1,0,0,1,4,20Zm8-5.989c.262,0,1-.01,1-.01v3.5L18.576,12,13,6.5V10a8.233,8.233,0,0,0-.891.052,7.982,7.982,0,0,0-6.892,6.08A10.625,10.625,0,0,1,12,14.01Z"
      />
    </g>
  );
};

export const EllipsisHIcon = () => (
  <g id="morel" transform="translate(-2.75 -9.75)">
    <circle
      id="Ellipse_503"
      data-name="Ellipse 503"
      cx="1"
      cy="1"
      r="1"
      transform="translate(11 11)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <circle
      id="Ellipse_504"
      data-name="Ellipse 504"
      cx="1"
      cy="1"
      r="1"
      transform="translate(18 11)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <circle
      id="Ellipse_505"
      data-name="Ellipse 505"
      cx="1"
      cy="1"
      r="1"
      transform="translate(4 11)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </g>
);

export const Chartline = () => (
  <path
    id="activity"
    d="M20.667,77.333h-18V64.667A.666.666,0,0,0,2,64H.667A.666.666,0,0,0,0,64.667v14A1.334,1.334,0,0,0,1.333,80H20.667a.666.666,0,0,0,.667-.667V78A.666.666,0,0,0,20.667,77.333Zm-1.333-12H14.414a1,1,0,0,0-.707,1.707l1.35,1.35L12,71.448,8.943,68.391a1.333,1.333,0,0,0-1.885,0L4.2,71.253a.667.667,0,0,0,0,.943l.943.943a.667.667,0,0,0,.943,0L8,71.219l3.057,3.057a1.333,1.333,0,0,0,1.885,0l4-4,1.35,1.35A1,1,0,0,0,20,70.919V66A.666.666,0,0,0,19.333,65.333Z"
    transform="translate(0 -64)"
  />
);

export const CheckCircleIcon = () => (
  <g id="Correct" transform="translate(-0.998 -0.982)">
    <path
      id="Path_34559"
      data-name="Path 34559"
      d="M22,11.08V12a10,10,0,1,1-5.93-9.14"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      id="Path_34560"
      data-name="Path 34560"
      d="M22,4,12,14.01l-3-3"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </g>
);

export const CheckIcon = () => (
  <path
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M17 1 6 12 1 7"
  />
);
export const CheckMark = () => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.41538 9.8036L0.190373 5.44535C-0.0634576 5.18351 -0.0634576 4.75898 0.190373 4.49711L1.10959 3.54888C1.36342 3.28702 1.775 3.28702 2.02883 3.54888L4.875 6.48478L10.9712 0.196377C11.225 -0.0654589 11.6366 -0.0654589 11.8904 0.196377L12.8096 1.14461C13.0635 1.40645 13.0635 1.83098 12.8096 2.09285L5.33462 9.80363C5.08076 10.0655 4.66921 10.0655 4.41538 9.8036Z"
      fill="var(--color-primary, #BE1622)"
    />
  </svg>
);

export const TimesIcon = () => (
  <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
);

export const CongratulationIcon = () => (
  <path d="M23.913 16.063c-.628-1.518-1.748-3.168-3.278-4.698a19.221 19.221 0 0 0-.532-.506c.171-.368.321-.745.445-1.127.604-1.856.598-3.78-.018-5.415a.499.499 0 1 0-.936.352c.535 1.424.536 3.112.002 4.755-.081.25-.187.494-.291.737-1.127-.922-2.279-1.623-3.364-2.073-.171-1.56-.801-3.004-1.914-4.117a.5.5 0 0 0-.707.707c.835.836 1.347 1.894 1.56 3.051-1.504-.406-2.803-.26-3.609.545a2.53 2.53 0 0 0-.637 1.13c-.014.023-.034.04-.045.066l-2.187 5.074-1.593 3.694v.001l-1.772 4.11-1.052 2.44-.001.002-1.945 4.511a.502.502 0 0 0 .105.552.512.512 0 0 0 .554.105l6.156-2.654h.001l2.443-1.054 11.428-4.927c.119-.039.229-.092.339-.146l.133-.057c.012-.005.02-.016.031-.022.18-.104.349-.225.497-.373.804-.804.949-2.102.545-3.606 1.161.216 2.219.727 3.05 1.558a.498.498 0 0 0 .708 0 .5.5 0 0 0 0-.707c-1.108-1.107-2.55-1.733-4.116-1.908zM11.98 8.98c.318-.317.805-.479 1.412-.479.469 0 1.015.108 1.605.302.042 1.857-.643 3.862-2.012 5.577-1.563-2.392-1.875-4.529-1.005-5.4zM3.457 28.543l1.223-2.837c.857.514 1.705.927 2.519 1.223l-3.742 1.614zm5.15-2.221c-1.089-.252-2.3-.778-3.533-1.531l.371-.86.577-1.339c1.751 1.313 3.523 2.224 5.11 2.641l-2.525 1.089zm4.261-1.836c-1.773-.035-4.151-1.093-6.436-2.846l.997-2.313c.053.054.102.11.156.164 2.092 2.093 4.425 3.646 6.587 4.432l-1.304.563zm2.713-1.171c-2.262-.531-4.973-2.215-7.289-4.532a18.262 18.262 0 0 1-.434-.449l.826-1.916.304-.704c.501.62 1.037 1.216 1.599 1.776 2.414 2.414 5.146 4.116 7.516 4.737l-2.522 1.088zm4.257-1.834c-2.399-.06-5.738-1.889-8.545-4.697a21.612 21.612 0 0 1-1.852-2.122l1.253-2.906c.455 1.812 1.732 3.941 3.671 5.88 1.945 1.944 4.077 3.213 5.893 3.664l-.42.181zm3.182-1.461a1.49 1.49 0 0 1-.469.292l-.132.057c-1.513.511-4.489-.583-7.347-3.44a16.446 16.446 0 0 1-1.48-1.715c1.528-1.82 2.335-3.967 2.393-6.01.904.427 1.877 1.049 2.864 1.882a9.922 9.922 0 0 1-1.541 2.07.5.5 0 0 0 .715.7 10.905 10.905 0 0 0 1.589-2.079c.106.101.212.19.317.296 1.346 1.347 2.283 2.714 2.865 3.95-1.497.044-3.061.471-4.542 1.342a.5.5 0 1 0 .506.862c1.457-.856 2.998-1.249 4.439-1.216.442 1.346.385 2.446-.177 3.009zM3.573 10.707a1.445 1.445 0 0 0 1.965-.526c.15-.262.209-.551.187-.83a2.057 2.057 0 0 0 1.603-1.022 2.065 2.065 0 0 0-.755-2.817.499.499 0 1 0-.5.865c.507.294.682.945.39 1.452a1.068 1.068 0 0 1-1.452.389.5.5 0 1 0-.5.865v.001a.438.438 0 1 1-.438.758.5.5 0 1 0-.5.865zm20.565 12.972a1.429 1.429 0 0 0-.475.705 2.025 2.025 0 0 0-.35-.068 2.025 2.025 0 0 0-1.515.443c-.431.345-.699.836-.759 1.384s.098 1.086.443 1.516a.5.5 0 1 0 .779-.626 1.058 1.058 0 0 1 .162-1.493 1.062 1.062 0 0 1 1.493.161v.001a.5.5 0 0 0 .779-.626v-.001a.438.438 0 1 1 .682-.548.5.5 0 1 0 .779-.627 1.435 1.435 0 0 0-2.018-.221zm.094-11.619c.384 0 .769-.146 1.061-.438.274-.274.408-.63.425-.989a1.48 1.48 0 0 0 .989-.425c.274-.274.408-.63.425-.989a1.48 1.48 0 0 0 .989-.425 1.501 1.501 0 0 0 0-2.121.5.5 0 0 0-.707.707.5.5 0 0 1-.707.707.5.5 0 0 0-.707.707.5.5 0 0 1-.707.707.5.5 0 0 0-.707.707.5.5 0 0 1-.707.707.5.5 0 0 0-.707.707 1.5 1.5 0 0 0 1.06.438zM4.5 18c.827 0 1.5-.673 1.5-1.5S5.327 15 4.5 15 3 15.673 3 16.5 3.673 18 4.5 18zm0-2c.275 0 .5.225.5.5s-.225.5-.5.5-.5-.225-.5-.5.225-.5.5-.5zm21-11c.827 0 1.5-.673 1.5-1.5S26.327 2 25.5 2 24 2.673 24 3.5 24.673 5 25.5 5zm0-2c.275 0 .5.225.5.5s-.225.5-.5.5-.5-.225-.5-.5.225-.5.5-.5zm-15 2c.827 0 1.5-.673 1.5-1.5S11.327 2 10.5 2 9 2.673 9 3.5 9.673 5 10.5 5zm0-2c.275 0 .5.225.5.5s-.225.5-.5.5-.5-.225-.5-.5.225-.5.5-.5zm6 24c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zm0 2c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5z" />
);

export const LockIcon = () => (
  <g id="password" transform="translate(-1.75 -0.75)">
    <rect
      id="Rectangle_3337"
      data-name="Rectangle 3337"
      width="18"
      height="11"
      rx="2"
      transform="translate(3 11)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      id="Path_34357"
      data-name="Path 34357"
      d="M7,11V7A5,5,0,0,1,17,7v4"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </g>
);

export const LanguageStrokeIcon = () => (
  <g id="language" transform="translate(-1 -1)">
    <circle
      id="Ellipse_642"
      data-name="Ellipse 642"
      cx="10"
      cy="10"
      r="10"
      transform="translate(2 2)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <line
      id="Line_1060"
      data-name="Line 1060"
      x2="20"
      transform="translate(2 12)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      id="Path_34623"
      data-name="Path 34623"
      d="M12,2a15.3,15.3,0,0,1,4,10,15.3,15.3,0,0,1-4,10A15.3,15.3,0,0,1,8,12,15.3,15.3,0,0,1,12,2Z"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </g>
);

export const TimesStrokeIcon = () => (
  <g id="x" transform="translate(2.121 1.914)">
    <line
      id="Line_926"
      data-name="Line 926"
      x1="16"
      y2="16"
      transform="translate(0 0.208)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <line
      id="Line_927"
      data-name="Line 927"
      x2="16"
      y2="16"
      transform="translate(0 0.208)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </g>
);

export const ClockTimeFillIcon = () => (
  <path
    id="time"
    d="M23,8A15,15,0,1,0,38,23,15,15,0,0,0,23,8Zm5.594,18.931h0l-1.21,1.512a.968.968,0,0,1-1.36.151h0l-4.052-3.007a2.419,2.419,0,0,1-.907-1.889V14.29a.968.968,0,0,1,.968-.968h1.935a.968.968,0,0,1,.968.968V23l3.508,2.571A.968.968,0,0,1,28.594,26.931Z"
    transform="translate(-8 -8)"
  />
);

export const UsersStrokeIcon = () => (
  <g id="users" transform="translate(0.25 -1.609)">
    <path
      id="Path_34322"
      data-name="Path 34322"
      d="M17,21V19a4,4,0,0,0-4-4H5a4,4,0,0,0-4,4v2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <circle
      id="Ellipse_483"
      data-name="Ellipse 483"
      cx="4"
      cy="4"
      r="4"
      transform="translate(5 3)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      id="Path_34323"
      data-name="Path 34323"
      d="M23,21V19a4,4,0,0,0-3-3.87"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      id="Path_34324"
      data-name="Path 34324"
      d="M16,3.13a4,4,0,0,1,0,7.75"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </g>
);

export const LearningPathsStrokeIcon = () => (
  <g id="learningPaths" transform="translate(-0.75 -1.75)">
    <path
      id="Path_34333"
      data-name="Path 34333"
      d="M2,3H8a4,4,0,0,1,4,4V21a3,3,0,0,0-3-3H2Z"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      id="Path_34334"
      data-name="Path 34334"
      d="M22,3H16a4,4,0,0,0-4,4V21a3,3,0,0,1,3-3h7Z"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </g>
);

export const ReportsStrokeIcon = () => (
  <g id="reports" transform="translate(-3.5 -2.5)">
    <line
      id="Line_906"
      data-name="Line 906"
      y1="10"
      transform="translate(19 10)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <line
      id="Line_907"
      data-name="Line 907"
      y1="16"
      transform="translate(12 4)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
    <line
      id="Line_908"
      data-name="Line 908"
      y1="6"
      transform="translate(5 14)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </g>
);

export const LogoSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
  >
    <path
      d="M21.8458 18.1658C21.6105 18.3445 21.32 18.5585 20.9744 18.8078C20.6651 19.0353 20.3357 19.2343 19.9905 19.4023C19.5636 19.5957 19.1162 19.7401 18.6569 19.8325C18.1576 19.9294 17.6498 19.976 17.1412 19.9715C15.9438 20.007 14.7791 19.5773 13.8916 18.7725C13.4641 18.3868 13.1256 17.9128 12.8995 17.3833C12.6734 16.8538 12.5652 16.2814 12.5823 15.7059C12.5436 14.8446 12.775 13.9927 13.2441 13.2693C13.7261 12.6082 14.3805 12.0923 15.1359 11.7779C16.0949 11.3757 17.1076 11.1156 18.1417 11.0058C19.3389 10.8521 20.5795 10.7392 21.8635 10.6672V10.5933C21.8895 10.2699 21.8148 9.9464 21.6497 9.66714C21.4846 9.38789 21.2372 9.16656 20.9413 9.03352C20.0766 8.70137 19.1517 8.55443 18.2267 8.60222C17.4457 8.61135 16.6706 8.73892 15.9279 8.98057C15.1127 9.23538 14.5259 9.43173 14.1696 9.56851H13.7725V6.28579C14.2336 6.16446 14.9859 6.02106 16.0216 5.8567C17.0532 5.69097 18.0963 5.60761 19.1411 5.60741C21.0054 5.46228 22.8719 5.85872 24.5163 6.74908C25.0758 7.15772 25.5215 7.70261 25.8111 8.33199C26.1007 8.96137 26.2245 9.65433 26.1709 10.3451V19.6108H21.8458V18.1658ZM21.8458 16.0479V13.2196C21.2575 13.2689 20.6188 13.3358 19.9298 13.4204C19.4021 13.4729 18.8801 13.5722 18.3701 13.7171C17.9882 13.8204 17.6423 14.0273 17.3707 14.315C17.1296 14.6034 17.0059 14.972 17.0243 15.3475C17.0186 15.5798 17.043 15.8119 17.0971 16.038C17.1646 16.2399 17.2915 16.4167 17.4611 16.5454C17.6541 16.7094 17.8797 16.8304 18.123 16.9006C18.5207 16.9911 18.9288 17.0282 19.3363 17.0109C19.7904 17.0064 20.2395 16.9162 20.66 16.745C21.0912 16.5801 21.492 16.3445 21.8458 16.0479Z"
      fill="white"
    />
    <path
      d="M41.6369 19.6076H37.2577V18.1935C36.6174 18.7339 35.9091 19.1882 35.1508 19.5447C34.435 19.8475 33.6634 19.9959 32.8863 19.9804C32.1193 20.0033 31.3581 19.8412 30.6669 19.5079C29.9757 19.1746 29.3749 18.6799 28.9152 18.0655C27.8509 16.5611 27.3262 14.7411 27.4261 12.901C27.4077 11.8547 27.5781 10.8137 27.9291 9.82786C28.2356 8.98179 28.7018 8.2025 29.3024 7.53239C29.8577 6.92104 30.5398 6.43841 31.3012 6.11826C32.0415 5.79226 32.8407 5.62109 33.6496 5.61526C34.3265 5.59644 35.0021 5.68429 35.6516 5.87559C36.2007 6.06048 36.7368 6.28158 37.2566 6.53743V0.744141H41.6369V19.6076ZM37.2599 15.8572V9.17044C36.9496 9.0393 36.6249 8.94525 36.2925 8.89026C35.9836 8.83595 35.6707 8.80754 35.3571 8.80532C34.8734 8.77034 34.3882 8.84944 33.9407 9.03624C33.4931 9.22304 33.0957 9.51233 32.7804 9.88081C32.1632 10.7467 31.8604 11.7975 31.9222 12.8591C31.8401 13.8779 32.0817 14.8967 32.6127 15.7701C32.8818 16.0874 33.2234 16.3353 33.6085 16.4927C33.9937 16.6502 34.4111 16.7125 34.8254 16.6746C35.2534 16.6699 35.6778 16.5953 36.0818 16.454C36.5011 16.3158 36.8975 16.1158 37.2577 15.8605L37.2599 15.8572Z"
      fill="white"
    />
    <path
      d="M52.0702 18.1658C51.8363 18.3445 51.5455 18.5585 51.1976 18.8078C50.8892 19.0355 50.5606 19.2345 50.2159 19.4024C49.789 19.5955 49.3416 19.7398 48.8823 19.8326C48.383 19.9294 47.8753 19.9759 47.3667 19.9716C46.1695 20.0075 45.005 19.5777 44.1182 18.7725C43.6907 18.3869 43.3522 17.9129 43.1261 17.3834C42.9 16.8539 42.7917 16.2815 42.8088 15.706C42.7702 14.8447 43.0016 13.9928 43.4707 13.2694C43.9524 12.6084 44.6064 12.0926 45.3613 11.778C46.3209 11.3762 47.3338 11.1161 48.3683 11.0059C49.564 10.8522 50.8046 10.7393 52.09 10.6672V10.5933C52.116 10.2701 52.0414 9.94678 51.8765 9.66757C51.7117 9.38837 51.4645 9.16694 51.169 9.0336C50.3039 8.70129 49.3787 8.55435 48.4532 8.6023C47.67 8.61312 46.8929 8.74331 46.1489 8.98837C45.3319 9.24355 44.7458 9.43952 44.3906 9.5763H43.9957V6.28587C44.4561 6.16379 45.2058 6.02076 46.2449 5.85678C47.2765 5.69108 48.3196 5.60772 49.3644 5.60748C51.229 5.46214 53.096 5.85859 54.7407 6.74915C55.3001 7.1578 55.7458 7.70268 56.0354 8.33206C56.325 8.96144 56.4489 9.65441 56.3953 10.3451V19.6109H52.0702V18.1658ZM52.0702 16.048V13.2197C51.4819 13.269 50.8436 13.3359 50.1553 13.4205C49.6276 13.473 49.1056 13.5723 48.5955 13.7172C48.2129 13.8202 47.8662 14.0271 47.5939 14.3151C47.3544 14.6043 47.2313 14.9724 47.2487 15.3475C47.2432 15.5799 47.268 15.8121 47.3226 16.038C47.3885 16.2402 47.5148 16.4173 47.6844 16.5455C47.8776 16.709 48.1031 16.83 48.3462 16.9006C48.7441 16.9905 49.1521 17.0276 49.5596 17.0109C50.0136 17.0067 50.4628 16.9165 50.8833 16.7451C51.3149 16.5803 51.716 16.3447 52.0702 16.048Z"
      fill="white"
    />
    <path
      d="M67.8367 10.1535H67.4496C67.1576 10.0688 66.8565 10.0199 66.5528 10.0079C66.1369 9.9748 65.7994 9.95825 65.5247 9.95825C64.9743 9.95415 64.4245 9.99621 63.8812 10.084C63.358 10.1783 62.8439 10.3175 62.3446 10.4999V19.6167H57.9688V5.99495H62.3446V7.9937C63.0829 7.31181 63.929 6.75683 64.8486 6.35124C65.4715 6.09825 66.1354 5.9607 66.8076 5.94531C66.962 5.94531 67.1385 5.94531 67.3271 5.95745C67.5157 5.96958 67.6911 5.9773 67.8356 5.99385L67.8367 10.1535Z"
      fill="white"
    />
    <path
      d="M77.2707 18.1656C77.0361 18.3443 76.7449 18.5583 76.397 18.8076C76.0885 19.035 75.7599 19.234 75.4153 19.4021C74.9887 19.5951 74.5417 19.7394 74.0828 19.8323C73.5817 19.9292 73.0721 19.9758 72.5617 19.9713C71.3643 20.0069 70.1998 19.5767 69.3132 18.7712C68.8857 18.3855 68.5472 17.9115 68.3211 17.382C68.095 16.8525 67.9867 16.2801 68.0038 15.7046C67.9666 14.8425 68.2004 13.9904 68.6723 13.268C69.1547 12.6077 69.8085 12.092 70.5629 11.7766C71.5221 11.3748 72.5347 11.1147 73.5688 11.0045C74.7652 10.8508 76.0055 10.7379 77.2894 10.6659V10.5919C77.3155 10.2686 77.2408 9.94509 77.0757 9.66584C76.9106 9.38659 76.6631 9.16526 76.3673 9.03222C75.5029 8.70021 74.5785 8.55328 73.6537 8.60092C72.8707 8.61091 72.0937 8.73998 71.3494 8.98368C70.5324 9.23886 69.9467 9.43483 69.5923 9.57161H69.1918V6.28559C69.6522 6.16352 70.4019 6.02049 71.441 5.8565C72.4722 5.69084 73.5149 5.60748 74.5593 5.60721C76.4242 5.46254 78.2912 5.85976 79.9357 6.75108C80.4955 7.15936 80.9415 7.70419 81.2311 8.33366C81.5208 8.96313 81.6444 9.65628 81.5903 10.3471V19.6128H77.2696L77.2707 18.1656ZM77.2707 16.0477V13.2194C76.6824 13.2687 76.0437 13.3356 75.3547 13.4202C74.827 13.4727 74.305 13.572 73.7949 13.7169C73.4127 13.8202 73.0665 14.0271 72.7944 14.3148C72.5539 14.6034 72.4306 14.972 72.4492 15.3473C72.443 15.5796 72.4675 15.8118 72.522 16.0378C72.5889 16.24 72.7159 16.417 72.886 16.5452C73.0786 16.7097 73.3043 16.8308 73.5478 16.9004C73.9456 16.9906 74.3536 17.0277 74.7612 17.0107C75.2152 17.0062 75.6643 16.916 76.0849 16.7448C76.5161 16.5798 76.9168 16.3442 77.2707 16.0477Z"
      fill="white"
    />
    <path
      d="M97.5032 12.612C97.5847 14.5177 96.9522 16.3853 95.7295 17.8493C95.19 18.4957 94.5126 19.0131 93.7469 19.3633C92.9813 19.7136 92.1469 19.8879 91.3051 19.8734C90.6306 19.8837 89.9578 19.8021 89.3052 19.6308C88.732 19.4695 88.1826 19.2329 87.6716 18.927L87.4885 19.6065H83.2969V0.744141H87.6727V7.41215C88.3055 6.90346 88.9942 6.46862 89.7255 6.11606C90.4836 5.77238 91.309 5.60241 92.1412 5.61857C92.905 5.57911 93.6668 5.72821 94.3593 6.05274C95.0518 6.37727 95.6538 6.86724 96.1123 7.47944C97.1188 8.99481 97.6069 10.7957 97.5032 12.612ZM93.0049 12.7046C93.0615 11.7336 92.8485 10.7659 92.3894 9.90838C92.1416 9.5641 91.8067 9.29187 91.419 9.11956C91.0314 8.94726 90.6049 8.88106 90.1833 8.92776C89.7538 8.93053 89.3267 8.99365 88.9148 9.11528C88.4776 9.24099 88.0583 9.42227 87.6672 9.65468V16.4815C87.957 16.5876 88.2567 16.6644 88.5618 16.711C88.8986 16.7543 89.2381 16.7746 89.5777 16.7716C90.0563 16.809 90.537 16.7368 90.9835 16.5606C91.43 16.3844 91.8304 16.1088 92.1545 15.7546C92.7828 14.8672 93.0834 13.7891 93.0049 12.7046Z"
      fill="white"
    />
    <path
      d="M11.5171 19.5452C10.9652 19.6852 10.4052 19.7917 9.84042 19.8639C9.12112 19.9487 8.39715 19.9878 7.6729 19.9809C6.16093 20.0963 4.65544 19.6864 3.41067 18.8205C2.89753 18.3058 2.50599 17.6828 2.26475 16.9973C2.0235 16.3117 1.93864 15.5809 2.0164 14.8583V7.69938H0V4.37254H2.0164V0H6.93716V4.37695H11.5171V7.70379H6.93716V13.1386C6.93716 13.6769 6.94157 14.1457 6.9504 14.545C6.9523 14.9139 7.02495 15.279 7.16439 15.6205C7.29416 15.9427 7.53153 16.2101 7.83616 16.3772C8.27362 16.5896 8.75817 16.6864 9.24366 16.6585C9.58223 16.6445 9.91782 16.5893 10.243 16.4941C10.5406 16.4258 10.8299 16.3252 11.1056 16.1941H11.5127L11.5171 19.5452Z"
      fill="white"
    />
  </svg>
);

export const AppStoreIcon = () => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="#fff"
  >
    <path
      d="M12.238 9.194A3.802 3.802 0 0114.1 5.958a3.883 3.883 0 00-3.074-1.618c-1.295-.08-2.589.81-3.236.81-.647 0-1.618-.81-2.75-.81A4.045 4.045 0 001.64 6.444c-1.537 2.588-.404 6.31 1.052 8.413.647 1.052 1.537 2.104 2.589 2.104s1.456-.648 2.75-.648c1.295 0 1.619.648 2.751.648 1.133 0 1.86-1.052 2.589-2.104.485-.647.809-1.456 1.133-2.346a3.64 3.64 0 01-2.266-3.317zM7.708 3.37A2.912 2.912 0 0010.62.457a2.912 2.912 0 00-2.912 2.912z"
      fill="currentColor"
    ></path>
  </svg>
);

export const PlayStoreIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="#fff"
  >
    <path
      d="M.236.912a.566.566 0 000 .081v13.413a.566.566 0 000 .081.404.404 0 01.105-.186l6.027-6.593-6.027-6.61A.405.405 0 01.236.904v.008zm.502 14.06a.567.567 0 00.348-.08l7.766-4.474-.016-.016-1.918-2.103L.932 14.85a.405.405 0 01-.194.122zm8.793-4.934l3.382-1.95a.444.444 0 000-.776L9.531 5.37a.405.405 0 01-.097.178L7.47 7.7l1.965 2.152c.049.056.081.121.097.186zM8.86 4.982L1.086.492A.566.566 0 00.738.427C.818.45.883.492.94.548l5.978 6.553 1.918-2.103.024-.024v.008z"
      fill="currentColor"
    ></path>
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.913 3.489A3.387 3.387 0 0024.53 1.09C22.428.523 14 .523 14 .523s-8.428 0-10.53.567A3.387 3.387 0 001.087 3.49c-.564 2.115-.564 6.53-.564 6.53s0 4.413.564 6.529c.31 1.167 1.223 2.048 2.383 2.36 2.102.567 10.53.567 10.53.567s8.428 0 10.53-.567c1.16-.312 2.073-1.193 2.383-2.36.563-2.116.563-6.53.563-6.53s0-4.414-.563-6.53z"
      fill="currentColor"
    ></path>
    <path
      d="M11.242 14.027V6.012l7.045 4.007-7.045 4.008z"
      fill="#00040D"
    ></path>
  </svg>
);

export const LinkedInIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.026 7.771H.336V21.88h4.69V7.77zM2.716.969C1.11.969.062 2.024.062 3.406c0 1.354 1.017 2.438 2.591 2.438h.03c1.636 0 2.654-1.084 2.654-2.438C5.307 2.024 4.319.97 2.716.97zM16.54 7.44c-2.488 0-3.602 1.368-4.226 2.329V7.77H7.625c.062 1.323 0 14.107 0 14.107h4.689V14c0-.422.03-.843.154-1.145.339-.842 1.11-1.714 2.406-1.714 1.696 0 2.376 1.294 2.376 3.19v7.547h4.689v-8.09c0-4.333-2.314-6.349-5.4-6.349z"
      fill="currentColor"
    ></path>
  </svg>
);

export const TwitterXIcon = () => (
  <svg width="32px" height="32px" viewBox="0 0 28 28" fill="none">
    <path
      d="M16.513 11.933L26.35.5h-2.331l-8.54 9.927L8.658.5H.79l10.315 15.011L.79 27.5h2.331l9.018-10.483L19.343 27.5h7.867L16.513 11.933zm-3.192 3.71l-1.045-1.494L3.961 2.255h3.58l6.71 9.598 1.045 1.495 8.723 12.477h-3.58l-7.118-10.181z"
      fill="currentColor"
    ></path>
  </svg>
);

export const TikTokIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 22 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.877 10.75a10.256 10.256 0 01-5.995-1.917v8.727a7.938 7.938 0 11-6.847-7.865v4.389a3.643 3.643 0 102.55 3.476V.5h4.297c-.003.363.027.725.09 1.083A5.966 5.966 0 0018.606 5.5a5.93 5.93 0 003.271.983v4.266z"
      fill="currentColor"
    ></path>
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.38 6.59A6.41 6.41 0 1019.79 13a6.402 6.402 0 00-6.41-6.41zm0 10.577a4.167 4.167 0 114.167-4.168 4.175 4.175 0 01-4.167 4.168zm8.167-10.839a1.5 1.5 0 11-1.5-1.5 1.49 1.49 0 011.5 1.496v.004zm4.25 1.518a7.399 7.399 0 00-2.02-5.24A7.448 7.448 0 0018.535.592C16.471.473 10.285.473 8.22.59a7.436 7.436 0 00-5.239 2.013A7.422 7.422 0 00.97 7.841c-.125 2.06-.125 8.25 0 10.31a7.399 7.399 0 002.02 5.24 7.456 7.456 0 005.23 2.018c2.064.118 8.25.118 10.315 0a7.398 7.398 0 005.239-2.02 7.447 7.447 0 002.02-5.238c.117-2.06.117-8.244 0-10.31l.005.005zm-2.67 12.52a4.22 4.22 0 01-2.376 2.375c-1.646.652-5.55.5-7.375.5-1.825 0-5.728.145-7.375-.5a4.219 4.219 0 01-2.375-2.375c-.652-1.647-.5-5.55-.5-7.375 0-1.825-.145-5.73.5-7.375A4.219 4.219 0 016.001 3.24c1.646-.653 5.55-.5 7.375-.5 1.825 0 5.729-.145 7.375.5a4.218 4.218 0 012.375 2.375c.653 1.646.5 5.55.5 7.375 0 1.825.153 5.735-.5 7.375z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    ></path>
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 15 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.091 9.644a.509.509 0 01.15.36v4.116a.51.51 0 01-.51.51H9.919v10.365a.51.51 0 01-.51.51H5.16m8.932-15.86a.509.509 0 00-.36-.15H9.92V7.09c0-1.157.276-1.743 1.782-1.743h2.184a.51.51 0 00.471-.315m-.267 4.612l-.353.354.002.003a.01.01 0 010 .004v4.115a.01.01 0 01-.002.007.01.01 0 01-.007.003H9.419v10.865a.01.01 0 01-.003.007s0 0 0 0l-.003.002a.01.01 0 01-.004 0H5.161l-.002.5m8.932-15.86l-.353.354a.01.01 0 00-.004-.003.01.01 0 00-.003 0H9.42V7.09c0-.584.06-1.193.452-1.636.404-.458 1.038-.607 1.83-.607h2.184a.01.01 0 00.007-.003.01.01 0 00.002-.003l.462.191m0 0a.509.509 0 00.039-.195V1.02a.51.51 0 00-.509-.515m.47 4.527l-.462-.191a.01.01 0 000-.004V1.015h0a.01.01 0 000-.004.01.01 0 00-.005-.006.01.01 0 00-.004 0m.001-.5h-3.242a5.694 5.694 0 00-6 6.152v2.836H1.39a.51.51 0 00-.51.51v4.11a.51.51 0 00.51.51h3.26v10.375M13.888.505v.5h0m0-.5l-.001.5s0 0 0 0M4.651 24.998a.51.51 0 00.508.507m-.508-.507l.5-.003s0 0 0 0m-.5.003h.5v-.003m.008.51v-.5h.001a.01.01 0 01-.006-.003l-.347.348.347-.348a.01.01 0 01-.003-.007m8.736-23.99H10.631l-.014-.001a5.194 5.194 0 00-5.473 5.612l.002.02V9.994H1.39a.01.01 0 00-.007.003.01.01 0 00-.003.007v4.11a.01.01 0 00.01.01h3.76v10.872"
      fill="currentColor"
      stroke="currentColor"
    ></path>
  </svg>
);

export const WhatsappIcon = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_423_1449)" fill="#fff">
      <path d="M19.732 15.5l-.01.08c-2.382-1.187-2.632-1.345-2.94-.883-.213.32-.835 1.044-1.022 1.258-.19.212-.378.228-.7.082-.325-.163-1.368-.504-2.603-1.61-.962-.86-1.608-1.917-1.798-2.242-.318-.548.346-.626.95-1.77.11-.227.054-.406-.026-.568-.082-.162-.728-1.755-1-2.39-.26-.632-.527-.552-.727-.552-.624-.054-1.08-.045-1.482.373-1.749 1.922-1.308 3.904.188 6.012 2.94 3.848 4.507 4.557 7.371 5.54.774.246 1.48.212 2.037.132.622-.099 1.914-.782 2.184-1.545.276-.764.276-1.398.195-1.544-.08-.146-.292-.227-.617-.374z"></path>
      <path d="M22.996 3.735C14.666-4.317.88 1.523.875 12.883c0 2.27.595 4.485 1.728 6.44L.766 26l6.863-1.79c8.563 4.626 19.132-1.516 19.137-11.32 0-3.44-1.344-6.678-3.787-9.111l.017-.043zm1.605 9.119c-.006 8.269-9.084 13.433-16.263 9.213l-.39-.232-4.062 1.056 1.088-3.949-.259-.406c-4.467-7.112.666-16.407 9.129-16.407 2.875 0 5.573 1.121 7.606 3.152a10.603 10.603 0 013.151 7.573z"></path>
    </g>
    <defs>
      <clipPath id="clip0_423_1449">
        <path fill="#fff" transform="translate(.766)" d="M0 0H26V26H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const MadaPaymentCard = ({ width = 18, height = 15 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 0H0V6H18V0Z" fill="#259BD6"></path>
    <path d="M18 9H0V15H18V9Z" fill="#84B740"></path>
  </svg>
);
export const VisaPaymentCard = ({
  width = 36,
  height = 12,
  color = "#fff",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 37 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6261 0.203003L12.7841 11.522H15.7311L17.5731 0.203003H14.6261ZM10.3051 0.203003L7.49506 7.98801L7.16306 6.312L7.09006 5.936C6.48131 4.64712 5.58703 3.51379 4.47506 2.62199C4.05904 2.29041 3.62104 1.98739 3.16406 1.715L5.71706 11.522H8.78706L13.4761 0.203003H10.3051ZM21.8051 3.345C21.8051 2.065 24.6751 2.23 25.9361 2.925L26.3561 0.494003C25.5043 0.189436 24.6094 0.0226718 23.7051 0C22.2431 0 18.7701 0.639994 18.7701 3.74699C18.7701 6.67199 22.8461 6.70799 22.8461 8.24699C22.8461 9.78599 19.1901 9.508 17.9841 8.539L17.5461 11.08C18.5989 11.5211 19.7317 11.739 20.8731 11.72C22.8841 11.72 25.9181 10.678 25.9181 7.845C25.9181 4.899 21.8051 4.624 21.8051 3.345ZM33.8301 0.203003H31.4611C31.1741 0.180875 30.8875 0.250762 30.643 0.402527C30.3984 0.554292 30.2086 0.780034 30.1011 1.047L25.7061 11.523H28.7781L29.3921 9.842H33.1381L33.4841 11.523H36.1901L33.8301 0.203003ZM30.2411 7.51801L31.7901 3.282L32.6611 7.51801H30.2411Z"
      fill={color}
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.211 1.26965C6.14862 0.949886 5.96649 0.666008 5.70181 0.476051C5.43713 0.286094 5.1099 0.204397 4.787 0.247642H0.0549984L0 0.439644C1.62549 0.846109 3.14495 1.59629 4.456 2.63964C5.69341 3.61412 6.64799 4.90152 7.221 6.36864L6.211 1.26965Z"
      fill={color}
    ></path>
  </svg>
);

export const MasterPaymentCard = ({ width = 26, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 31 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.831 2.697h-8.267v14.856h8.267V2.697z" fill="#FF5F00"></path>
    <path
      d="M12.089 10.125a9.432 9.432 0 013.608-7.428 9.448 9.448 0 100 14.856 9.433 9.433 0 01-3.608-7.428z"
      fill="#EB001B"
    ></path>
    <path
      d="M30.985 10.125a9.447 9.447 0 01-15.287 7.428 9.451 9.451 0 000-14.856 9.448 9.448 0 0115.287 7.428zM30.083 15.98v-.304h.123v-.062h-.313v.062h.123v.304h.067zm.606 0v-.367h-.095l-.11.253-.11-.253h-.096v.367h.067v-.277l.103.239h.07l.104-.24v.278h.067z"
      fill="#F79E1B"
    ></path>
  </svg>
);

export const SecurityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.625 4.875V7.5H1.5C1.10218 7.5 0.720643 7.65803 0.439339 7.93934C0.158034 8.22064 0 8.60218 0 9V16.5C0 16.8978 0.158034 17.2794 0.439339 17.5607C0.720643 17.842 1.10218 18 1.5 18H13.5C13.8978 18 14.2794 17.842 14.5607 17.5607C14.842 17.2794 15 16.8978 15 16.5V9C15 8.60218 14.842 8.22064 14.5607 7.93934C14.2794 7.65803 13.8978 7.5 13.5 7.5H12.375V4.875C12.375 3.58207 11.8614 2.34209 10.9471 1.42785C10.0329 0.513613 8.79293 0 7.5 0C6.20707 0 4.9671 0.513613 4.05286 1.42785C3.13862 2.34209 2.625 3.58207 2.625 4.875ZM4.5 7.5V4.875C4.5 4.07935 4.81607 3.31629 5.37868 2.75368C5.94129 2.19107 6.70435 1.875 7.5 1.875C8.29565 1.875 9.05871 2.19107 9.62132 2.75368C10.1839 3.31629 10.5 4.07935 10.5 4.875V7.5H4.5ZM6 11.625C6.00001 11.3649 6.06767 11.1092 6.19633 10.8832C6.325 10.6571 6.51023 10.4683 6.73386 10.3355C6.9575 10.2026 7.21184 10.1302 7.47192 10.1253C7.73199 10.1205 7.98887 10.1833 8.21732 10.3077C8.44577 10.4321 8.63795 10.6138 8.77498 10.8349C8.91201 11.056 8.9892 11.3089 8.99895 11.5688C9.0087 11.8288 8.95068 12.0868 8.8306 12.3175C8.71051 12.5483 8.53249 12.7438 8.314 12.885C8.314 12.885 8.461 13.77 8.625 14.812C8.625 14.8859 8.61043 14.959 8.58212 15.0273C8.55382 15.0955 8.51233 15.1575 8.46004 15.2097C8.40774 15.2619 8.34567 15.3033 8.27737 15.3315C8.20907 15.3597 8.13588 15.3741 8.062 15.374H6.938C6.78894 15.374 6.646 15.3148 6.5406 15.2094C6.43521 15.104 6.376 14.9611 6.376 14.812L6.687 12.885C6.47631 12.7491 6.30305 12.5626 6.18304 12.3425C6.06302 12.1224 6.00009 11.8757 6 11.625Z"
      fill="#B0B0BA"
    />
  </svg>
);

export const LeftArrowLine = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99967 15.8334L15.833 10.0001L9.99967 4.16675"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16634 10H15.833"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RightArrowLine = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0003 15.8334L4.16699 10.0001L10.0003 4.16675"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8337 10H4.16699"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LeftArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.3984 12.8008L5.59844 8.00078L10.3984 3.20078"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.74 19.53V11.88H0V7.785H7.74V0H11.79V7.785H19.53V11.88H11.79V19.53H7.74Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MinusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="5"
      viewBox="0 0 18 5"
      fill="none"
    >
      <path d="M17.5 0V5H0V0H17.5Z" fill="currentColor" />
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 17.3333V27.9999"
        stroke="currentColor"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33338 19.8653C2.61997 17.093 1.90425 12.9314 3.5356 9.41186C5.16695 5.89236 8.80524 3.74885 12.6744 4.0277C16.5436 4.30654 19.8369 6.9496 20.9467 10.6667H23.3334C25.9765 10.6664 28.3085 12.3957 29.0757 14.9251C29.843 17.4544 28.8646 20.1879 26.6667 21.656"
        stroke="currentColor"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 22.6666L16.0003 17.3333L21.3337 22.6666"
        stroke="currentColor"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
      <polyline points="13 2 13 9 20 9"></polyline>
    </svg>
  );
};

export const TrashIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  );
};
export const PaymentCardBg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="435"
      height="242"
      viewBox="0 0 435 242"
      fill="none"
    >
      <mask
        id="mask0_22_965"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="435"
        height="242"
      >
        <rect
          x="1"
          y="1"
          width="433"
          height="240"
          rx="13"
          fill="#F3F3F3"
          stroke="#BE1622"
          strokeWidth="2"
        />
      </mask>
      <g mask="url(#mask0_22_965)">
        <path
          d="M470 61.9999C206.8 6.79991 58.3333 166.333 17 253L470 269V61.9999Z"
          fill="currentColor"
          fillOpacity="0.29"
        />
        <path
          d="M-124 108C139.2 163.2 287.667 3.66676 329 -82.9999L-124 -99V108Z"
          fill="currentColor"
          fillOpacity="0.29"
        />
      </g>
    </svg>
  );
};

export const MasterCardIcon = (props) => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="110"
    height="87"
    viewBox="0 0 110 87"
    fill="none"
  >
    <path
      d="M19.9975 85.3293V79.6697C19.9975 77.5001 18.6769 76.0852 16.413 76.0852C15.2811 76.0852 14.0549 76.4625 13.2059 77.6888C12.5456 76.6512 11.6024 76.0852 10.1875 76.0852C9.24418 76.0852 8.30091 76.3682 7.5463 77.4058V76.2739H5.56543V85.3293H7.5463V80.3299C7.5463 78.7264 8.39524 77.9718 9.71582 77.9718C11.0364 77.9718 11.6967 78.8207 11.6967 80.3299V85.3293H13.6776V80.3299C13.6776 78.7264 14.6208 77.9718 15.8471 77.9718C17.1677 77.9718 17.8279 78.8207 17.8279 80.3299V85.3293H19.9975ZM49.3332 76.2739H46.1261V73.5384H44.1452V76.2739H42.353V78.0661H44.1452V82.2165C44.1452 84.2917 44.9941 85.5179 47.258 85.5179C48.1069 85.5179 49.0502 85.2349 49.7105 84.8576L49.1445 83.1598C48.5786 83.5371 47.9183 83.6314 47.4466 83.6314C46.5034 83.6314 46.1261 83.0654 46.1261 82.1222V78.0661H49.3332V76.2739ZM66.1234 76.0852C64.9915 76.0852 64.2369 76.6512 63.7652 77.4058V76.2739H61.7843V85.3293H63.7652V80.2356C63.7652 78.7264 64.4255 77.8774 65.6518 77.8774C66.0291 77.8774 66.5007 77.9718 66.878 78.0661L67.444 76.1795C67.0667 76.0852 66.5007 76.0852 66.1234 76.0852ZM40.7494 77.0285C39.8061 76.3682 38.4856 76.0852 37.0707 76.0852C34.8068 76.0852 33.2976 77.2171 33.2976 79.0094C33.2976 80.5186 34.4295 81.3675 36.4104 81.6505L37.3536 81.7448C38.3912 81.9335 38.9572 82.2165 38.9572 82.6881C38.9572 83.3484 38.2026 83.82 36.882 83.82C35.5614 83.82 34.5238 83.3484 33.8635 82.8768L32.9203 84.386C33.9579 85.1406 35.3728 85.5179 36.7877 85.5179C39.4288 85.5179 40.9381 84.2917 40.9381 82.5938C40.9381 80.9902 39.7118 80.1413 37.8253 79.8583L36.882 79.764C36.0331 79.6697 35.3728 79.481 35.3728 78.915C35.3728 78.2547 36.0331 77.8774 37.0707 77.8774C38.2026 77.8774 39.3345 78.3491 39.9005 78.6321L40.7494 77.0285ZM93.3839 76.0852C92.252 76.0852 91.4974 76.6512 91.0257 77.4058V76.2739H89.0449V85.3293H91.0257V80.2356C91.0257 78.7264 91.686 77.8774 92.9123 77.8774C93.2896 77.8774 93.7612 77.9718 94.1385 78.0661L94.7045 76.1795C94.3272 76.0852 93.7612 76.0852 93.3839 76.0852ZM68.1043 80.8016C68.1043 83.5371 69.9908 85.5179 72.9149 85.5179C74.2355 85.5179 75.1788 85.2349 76.1221 84.4803L75.1788 82.8768C74.4242 83.4427 73.6696 83.7257 72.8206 83.7257C71.2171 83.7257 70.0851 82.5938 70.0851 80.8016C70.0851 79.1037 71.2171 77.9718 72.8206 77.8774C73.6696 77.8774 74.4242 78.1604 75.1788 78.7264L76.1221 77.1228C75.1788 76.3682 74.2355 76.0852 72.9149 76.0852C69.9908 76.0852 68.1043 78.0661 68.1043 80.8016ZM86.4037 80.8016V76.2739H84.4228V77.4058C83.7625 76.5569 82.8193 76.0852 81.593 76.0852C79.0462 76.0852 77.0653 78.0661 77.0653 80.8016C77.0653 83.5371 79.0462 85.5179 81.593 85.5179C82.9136 85.5179 83.8569 85.0463 84.4228 84.1973V85.3293H86.4037V80.8016ZM79.1405 80.8016C79.1405 79.198 80.1781 77.8774 81.876 77.8774C83.4796 77.8774 84.6115 79.1037 84.6115 80.8016C84.6115 82.4051 83.4796 83.7257 81.876 83.7257C80.1781 83.6314 79.1405 82.4051 79.1405 80.8016ZM55.4644 76.0852C52.8233 76.0852 50.9367 77.9718 50.9367 80.8016C50.9367 83.6314 52.8233 85.5179 55.5588 85.5179C56.8793 85.5179 58.1999 85.1406 59.2375 84.2917L58.2942 82.8768C57.5396 83.4427 56.5964 83.82 55.6531 83.82C54.4268 83.82 53.2006 83.2541 52.9176 81.6505H59.6148V80.8959C59.7092 77.9718 58.0113 76.0852 55.4644 76.0852ZM55.4644 77.7831C56.6907 77.7831 57.5396 78.5377 57.7283 79.9526H53.0119C53.2006 78.7264 54.0495 77.7831 55.4644 77.7831ZM104.609 80.8016V72.6895H102.628V77.4058C101.968 76.5569 101.024 76.0852 99.7981 76.0852C97.2513 76.0852 95.2704 78.0661 95.2704 80.8016C95.2704 83.5371 97.2513 85.5179 99.7981 85.5179C101.119 85.5179 102.062 85.0463 102.628 84.1973V85.3293H104.609V80.8016ZM97.3456 80.8016C97.3456 79.198 98.3832 77.8774 100.081 77.8774C101.685 77.8774 102.817 79.1037 102.817 80.8016C102.817 82.4051 101.685 83.7257 100.081 83.7257C98.3832 83.6314 97.3456 82.4051 97.3456 80.8016ZM31.1281 80.8016V76.2739H29.1472V77.4058C28.4869 76.5569 27.5436 76.0852 26.3174 76.0852C23.7705 76.0852 21.7897 78.0661 21.7897 80.8016C21.7897 83.5371 23.7705 85.5179 26.3174 85.5179C27.638 85.5179 28.5812 85.0463 29.1472 84.1973V85.3293H31.1281V80.8016ZM23.7705 80.8016C23.7705 79.198 24.8081 77.8774 26.506 77.8774C28.1096 77.8774 29.2415 79.1037 29.2415 80.8016C29.2415 82.4051 28.1096 83.7257 26.506 83.7257C24.8081 83.6314 23.7705 82.4051 23.7705 80.8016Z"
      fill="black"
    />
    <path
      d="M69.8019 7.50928H40.0889V60.8984H69.8019V7.50928Z"
      fill="#FF5F00"
    />
    <path
      d="M41.9755 34.2038C41.9755 23.3562 47.0692 13.7349 54.8983 7.50928C49.1444 2.98158 41.8812 0.246094 33.9577 0.246094C15.1867 0.246094 0 15.4327 0 34.2038C0 52.9749 15.1867 68.1616 33.9577 68.1616C41.8812 68.1616 49.1444 65.4261 54.8983 60.8984C47.0692 54.7671 41.9755 45.0514 41.9755 34.2038Z"
      fill="#EB001B"
    />
    <path
      d="M109.891 34.2038C109.891 52.9749 94.7039 68.1616 75.9328 68.1616C68.0093 68.1616 60.7461 65.4261 54.9922 60.8984C62.9157 54.6728 67.915 45.0514 67.915 34.2038C67.915 23.3562 62.8213 13.7349 54.9922 7.50928C60.7461 2.98158 68.0093 0.246094 75.9328 0.246094C94.7039 0.246094 109.891 15.5271 109.891 34.2038Z"
      fill="#F79E1B"
    />
  </svg>;
};

export const TransactionsIcon = () => (
    <g><path d="M3.25 10A.75.75 0 0 1 4 9.25h14.189l-2.72-2.72a.75.75 0 1 1 1.061-1.061l4 4a.75.75 0 0 1-.53 1.28H4a.75.75 0 0 1-.75-.75zM20 13.25H4a.75.75 0 0 0-.53 1.28l4 4a.748.748 0 0 0 1.06 0 .75.75 0 0 0 0-1.061l-2.72-2.72h14.189a.75.75 0 0 0 0-1.5z" fill="#bbbabf" opacity="1" data-original="#000000" class=""></path></g>
)
export const NoSubscriptionIcon = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="32" fill="#F4F6F0" />
    <rect x="22" y="31" width="20" height="2" rx="1" fill="#B0B0BA" />
  </svg>
);